import window from 'browser-lib/window'
import cookie from 'cookie'
import { get, startsWith } from 'lodash'

const pathHelper = () => {
  const { remembered } = cookie.parse(document.cookie)
  if (remembered) {
    const fakeLink = document.createElement('a')
    fakeLink.href = remembered
    const path = fakeLink.pathname + get(fakeLink, 'search', '')
    if (startsWith(path, `${import.meta.env.BASE_URL}/`)) {
      return path
    }
  }
}

const hasRememberedRoute = () => !!pathHelper()

const handleRemembered = () => {
  const path = pathHelper()
  if (path) {
    const rawCookie = cookie.serialize('remembered', undefined, {
      maxAge: 0,
      path: '/',
    })
    document.cookie = rawCookie
    window.location.href = path
  }
}

export default {
  hasRememberedRoute,
  handleRemembered,
}
